module.exports = __webpack_public_path__ + "img/plant_3.5dc59799.webp";